
import { consumables } from '../../../mocks/equipmentHireCatalogue';
import { useScrollAnimation, useStaggeredAnimation } from '../../../hooks/useScrollAnimation';

export default function ConsumablesSection() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const {
    ref: gridRef,
    isVisible: gridVisible,
    getItemDelay,
  } = useStaggeredAnimation(consumables.length, { staggerDelay: 120 });

  return (
    <section id="consumables" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div
          ref={titleRef}
          className={`text-center mb-14 transition-all duration-700 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-50 border border-amber-200 mb-4">
            <i className="ri-snowflake-line text-amber-600 text-sm"></i>
            <span className="text-amber-700 text-xs tracking-widest uppercase font-semibold">
              Event Essentials
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-stone-900 mb-4">
            <strong>Consumables</strong>
          </h2>
          <p className="text-stone-500 text-sm max-w-xl mx-auto leading-relaxed">
            Stock up on event essentials. Premium ice and supplies delivered fresh to your venue across Melbourne.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {consumables.map((item, index) => (
            <div
              key={item.id}
              style={getItemDelay(index)}
              className={`bg-stone-50 rounded-lg overflow-hidden border border-stone-100 hover:border-amber-200 hover:shadow-lg hover:-translate-y-1 transition-all duration-500 group ${
                gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <div className="relative w-full h-56 overflow-hidden bg-stone-100">
                <img
                  src={item.image}
                  alt={`${item.name} - event consumable hire Melbourne`}
                  title={`${item.name} event consumable Melbourne`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-3 right-3 px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-semibold text-amber-700">
                  No Min.
                </div>
              </div>

              <div className="p-5">
                <h3 className="font-display text-lg text-stone-900 mb-1">{item.name}</h3>
                <p className="text-stone-600 text-xs leading-relaxed mb-4">{item.description}</p>

                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-xl font-bold text-amber-600">${item.price.toFixed(2)}</span>
                    <span className="text-stone-400 text-xs ml-1">{item.unit}</span>
                  </div>
                  <a
                    href="#hire-inquiry"
                    className="px-4 py-2 bg-stone-900 text-white text-xs font-medium rounded-full hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Enquire
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
